import { useRef, useEffect, useState } from 'react';
import Tesseract, { createWorker } from 'tesseract.js';
import moment from 'moment';
import Cookies from 'universal-cookie';

const debugMode = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const _basename = window.location.origin + "/CGPP-LTS/";
export const api_base = "http://localhost:5047/";
export const ajax_api = (debugMode ? api_base : _basename) + "api/";

export const ocr = async(img, logger) => {
    const worker = await createWorker({
        workerPath: _basename + 'plugins/tesseractjs_data/js/worker.min.js',
        langPath: _basename + 'plugins/tesseractjs_data/',
        corePath: _basename + 'plugins/tesseractjs_data/js/tesseract-core.wasm.js',
        logger: logger != null ? m => logger(m) : m => console.log(m),
        cacheMethod: 'none'
    });

    await worker.loadLanguage('eng');
    await worker.initialize('eng');

    const data = await worker.recognize(img);
    await worker.terminate();

    return data;
}

export function wait(ms) {
  return new Promise( (resolve) => {setTimeout(resolve, ms)});
}

export function usePrevious(value, ignoreList = []) {
    const ref = useRef();
    useEffect(() => {
      if(ignoreList.length > 0){
          if(!ignoreList.includes(value)){
            ref.current = value;
          }
      }
    });
    return ref.current;
}

export const birthdayDPicker = {
    limitYear: moment().subtract(18, 'years').format("YYYY"),
    absolute: true,
    yearRange: 60
};

export const shortNum = num => {
    num = num.toString().replace(/[^0-9.]/g, '');
    if (num < 1000) {
        return num;
    }
    let si = [
        { v: 1E3, s: "K" },
        { v: 1E6, s: "M" },
        { v: 1E9, s: "B" },
        { v: 1E12, s: "T" },
        { v: 1E15, s: "P" },
        { v: 1E18, s: "E" }
    ];
    let index;
    for (index = si.length - 1; index > 0; index--) {
        if (num >= si[index].v) {
            break;
        }
    }
    return (num / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[index].s;
};



export const createArrayWithLength = (length, startWith = 0) => {
    var arr = [];
    for(var i=startWith; i<length + startWith; i++) {
        arr.push(i);
    }
    return arr;
}

export const getAccess = access_id => {
    var cookies = new Cookies();
    var current_access = cookies.get('creds').Access.split(",");
    
    return current_access.includes(access_id) || current_access.includes(access_id.toString());
}